import React, { FC } from 'react';

import PartCasesContainer from '@/components/part-cases-container';
import { IListCases } from '@/contentful/utils/cases';

import styles from './part-cases-list.module.scss';

interface IPartCasesProps {
  data: {
    lang: string;
    cases: IListCases[];
    buttonTitle?: string;
  };
}

const PartCasesList: FC<IPartCasesProps> = ({ data }) => (
  <section className={styles.container}>
    <PartCasesContainer cases={data.cases} lang={data.lang} />
  </section>
);

export default PartCasesList;
